module.exports = __webpack_public_path__ + "img/motorway_9x3_z16.bb9b1a87.svg";